import { render } from "./KanbanDetail.vue?vue&type=template&id=3d53bf1a"
import script from "./KanbanDetail.vue?vue&type=script&lang=js"
export * from "./KanbanDetail.vue?vue&type=script&lang=js"
script.render = render

export default script